import type { UseFormReturn } from 'react-hook-form';

// import { EquiposMaterialesViewOTInstallFormTab } from '@/erp/operaciones/auditoria/instalaciones/shared/components';
import { EquipoAdicionalInstallTectAsig } from '@/erp/tecnico/orden-trabajo/shared/components/SaveOrdenTrabajo/equipos';
// import { tabTextLabelSx } from '@/shared';
// import { TabTextLabel } from '@/shared/components/ui';
// import { CustomToggleSectionBtnOnly } from '@/shared/components/ui/Sections';
import type { Contrato } from '@/shared/interfaces';
import type { ClienteFibraSummaryFormType } from './SaveContractFibra';
import {
  // ClienteFibraOTServicePart,
  ClienteFibraServicePlanTable,
} from './servicios';
import { OTDetalleInstallTecnicoFormTab, OTInstalacionTecnicoFormTab } from '@/erp/tecnico/orden-trabajo/shared/components';
import { CustomTabPanel, FormTabsOnly, NestedTabsScene, TabTextLabel } from '@/shared/components/ui';
import { Tab } from '@mui/material';
import { a11yProps, tabTextLabelSx, useTabsFormOnly } from '@/shared';

export type ClienteFibraServiceFormTabProps = {
  contract: Contrato;
  form: UseFormReturn<ClienteFibraSummaryFormType>;
};

const ClienteFibraServiceFormTab: React.FC<ClienteFibraServiceFormTabProps> = ({
  contract,
  form,
}) => {
  
  ///* hooks -------------------------
  const { handleMethodChange, valueTab } = useTabsFormOnly({
    initialTabValue: 1,
  });

  ///* form -------------------------
  const { errors } = form.formState;
  return (
    <>
      <EquipoAdicionalInstallTectAsig
        ordenTrabajo={contract.orden_trabajo_data!}
        isOnlyView
      />

      {/* ---------------- Equipos Adicionales Preventa - Table ---------------- */}
      {/* <TabTextLabel
        text="EQUIPOS ADICIONALES PREVENTA"
        sx={{
          ...tabTextLabelSx,
          pb: '3px',
          pt: '54px',
          mt: '0px',
        }}
      /> */}

      

      {/* ---------------- OT info ---------------- */}
      {/* <CustomToggleSectionBtnOnly btnText="Ver Detalle Instalación">
        <ClienteFibraOTServicePart contract={contract} form={form} />
      </CustomToggleSectionBtnOnly> */}
      <TabTextLabel
        text="Detalles de Instalación"
        sx={{
          ...tabTextLabelSx,
          pb: '3px',
          pt: '54px',
          mt: '0px',
        }}
      />
      <NestedTabsScene
        tabs={
          <FormTabsOnly onChange={handleMethodChange} value={valueTab}>
            <Tab label="ORDEN TRABAJO" value={1} {...a11yProps(1)} />
            <Tab label="DETALLE INSTALACIÓN" value={2} {...a11yProps(2)} />
          </FormTabsOnly>
        }
      >
        {/* ===================== ORDEN TRABAJO ===================== */}
        <CustomTabPanel index={valueTab} value={1}>
          <OTInstalacionTecnicoFormTab
            form={form}
            errors={errors}
            shrink={true}
            viewContratos={true}
          />
        </CustomTabPanel>

        {/* ===================== DETALLES DE INSTALACIÓN ===================== */}
        <CustomTabPanel index={valueTab} value={2}>
          <OTDetalleInstallTecnicoFormTab
            form={form as any}
            errors={errors}
            shrink={true}
            coords={contract.orden_trabajo_data?.coordenadas || ''}
            ordenTrabajo={contract.orden_trabajo_data!}
            isOnlyView
          />
        </CustomTabPanel>
      </NestedTabsScene>
      {/* ---------------- service plan table ---------------- */}
      <ClienteFibraServicePlanTable contract={contract} />

      

      {/* ---------------- Equipos asignados OT - Table ---------------- */}
      {/* <CustomToggleSectionBtnOnly
        btnText="Ver Equipos Asignados"
        isFirstSection
      >
        // <EquiposMaterialesViewOTInstallFormTab
          ordenTrabajo={contract.orden_trabajo_data!}
        />
      </CustomToggleSectionBtnOnly> */}
      
    </>
  );
};

export default ClienteFibraServiceFormTab;
